import { useMutation, useQueryClient } from '@tanstack/react-query';
import { businessAccessApi } from '../api/businessAccessClient';
import { VoidPaymentRequest, VoidPaymentResponse } from '../types/payment.types';
import { toaster } from 'baseui/toast';
import { getApiErrorMessage } from '../utils/apiErrors';

/**
 * Custom hook to void a payment
 * @returns React Query mutation result
 */
export const useVoidPayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: VoidPaymentRequest) => {
      const response = await businessAccessApi<VoidPaymentResponse>({
        url: '/void',
        method: 'POST',
        data: request,
      });

      return response;
    },
    onSuccess: (data) => {
      // Show success notification
      toaster.positive(`Payment voided successfully. Auth Code: ${data.authCode}`, {
        autoHideDuration: 5000,
      });

      // Invalidate payments query to refresh the list
      queryClient.invalidateQueries({ queryKey: ['business-payments'] });
    },
    onError: (error: any) => {
      // SAM-544: coherent message when portalApi's SAM-538 VOID_PAYMENT
      // check denies this (or any other failure) — see utils/apiErrors.ts.
      toaster.negative(getApiErrorMessage(error, 'Failed to void payment'), {
        autoHideDuration: 5000,
      });
    },
  });
};
